import { getBuildingFormSchema } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import type { z } from "zod";

export const getHouseFormSchema = (t: TranslateFunction) =>
	getBuildingFormSchema(t);

export type HouseFormInput = z.input<ReturnType<typeof getHouseFormSchema>>;
export type HouseFormOutput = z.output<ReturnType<typeof getHouseFormSchema>>;
